import type { CSSProperties } from 'react'

type ShimmerProps = {
  width?: string | number
  height?: string | number
  radius?: string | number
  className?: string
  style?: CSSProperties
}

export function ShimmerBlock({ width = '100%', height = 16, radius = 4, className = '', style }: ShimmerProps) {
  return (
    <div
      className={`skel ${className}`.trim()}
      style={{ width, height, borderRadius: radius, ...style }}
    />
  )
}

export function ShimmerCircle({ size = 48, className = '' }: { size?: number; className?: string }) {
  return <ShimmerBlock className={className} width={size} height={size} radius="50%" />
}

export function ShimmerLines({ count = 3, lastWidth = '70%' }: { count?: number; lastWidth?: string }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {Array.from({ length: count }).map((_, i) => (
        <ShimmerBlock key={i} height={14} width={i === count - 1 ? lastWidth : '100%'} />
      ))}
    </div>
  )
}

export function ShimmerRelGroup({ cards = 4 }: { cards?: number }) {
  return (
    <div className="rel-group">
      <ShimmerBlock width={110} height={12} style={{ marginBottom: 12 }} />
      <div className="rel-cards">
        {Array.from({ length: cards }).map((_, i) => (
          <div className="rel-card" key={i}>
            <ShimmerBlock className="cover" width="100%" height={96} radius={0} />
            <div className="body">
              <ShimmerBlock width="80%" height={14} style={{ marginBottom: 6 }} />
              <ShimmerBlock width="50%" height={12} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
